import { ref } from 'vue';
import { errorHandler, type AppError, ErrorCategory } from '@/utils/errorHandler';
import { useModal } from './useModal';

export function useErrorHandler() {
  const lastError = ref<AppError | null>(null);
  const isError = ref(false);
  const modal = useModal();

  /**
   * Behandelt den Fehler und zeigt optional ein Modal an.
   */
  const handleError = async (error: unknown, context?: string, showModal = true) => {
    const appError = errorHandler.handle(error, context);
    lastError.value = appError;
    isError.value = true;

    if (showModal) {
      await modal.error(appError.userMessage, context || 'Fehler');
    }

    return appError;
  };

  const clearError = () => {
    lastError.value = null;
    isError.value = false;
  };

  return {
    lastError,
    isError,
    handleError,
    clearError,
    ErrorCategory
  };
}

